import React, { Suspense } from "react";
import { SensorKitModel } from "@/sensorKits/sensorKit";
import { Card } from "@/components/ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import QuickTooltip from "@/components/quick-tooltip";
import { VersionMultiSelect } from "./VersionMultiSelect";

interface FilterBarProps {
  modelFilter: SensorKitModel | "";
  onModelChange: (value: string) => void;
  versionFilter: string[];
  onVersionChange: (versions: string[]) => void;
  hasCurrentInstallationFilter: boolean | undefined;
  onInstallationStatusChange: (value: boolean | undefined) => void;
}

export const FilterBar = ({
  modelFilter,
  onModelChange,
  versionFilter,
  onVersionChange,
  hasCurrentInstallationFilter,
  onInstallationStatusChange,
}: FilterBarProps) => {
  return (
    <Card className="p-4 mb-4">
      <h2 className="font-semibold mb-2">Filters</h2>
      <div className="flex space-x-4 items-center">
        <div>
          <QuickTooltip text="Filter by sensor kit model type">
            <Select value={modelFilter} onValueChange={onModelChange}>
              <SelectTrigger className="w-[180px]">
                <SelectValue placeholder="Filter by Model"/>
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="">All Models</SelectItem>
                <SelectItem value="combustion">Combustion</SelectItem>
                <SelectItem value="point_capture">Point Capture</SelectItem>
                <SelectItem value="direct_air_capture">Direct Air Capture</SelectItem>
                <SelectItem value="refrigerant">Refrigerant</SelectItem>
              </SelectContent>
            </Select>
          </QuickTooltip>
        </div>

        <div>
          <QuickTooltip text="Filter by sensor kit version (select a model first)">
            {modelFilter ? (
              <Suspense fallback={
                <div className="w-[180px] h-10 flex items-center justify-center border rounded-md bg-gray-50">
                  <span className="text-sm text-gray-500">Loading...</span>
                </div>
              }>
                <VersionMultiSelect
                  model={modelFilter}
                  selected={versionFilter}
                  onChange={onVersionChange}
                />
              </Suspense>
            ) : (
              <div className="w-[180px] h-10 flex items-center justify-center border rounded-md bg-gray-50">
                <span className="text-sm text-gray-500">Filter by Version</span>
              </div>
            )}
          </QuickTooltip>
        </div>

        <div>
          <QuickTooltip text="Filter by installation status">
            <Select
              value={hasCurrentInstallationFilter === undefined ? "" : hasCurrentInstallationFilter.toString()}
              onValueChange={(value: string) => {
                if (value === "") {
                  onInstallationStatusChange(undefined);
                } else {
                  onInstallationStatusChange(value === "true");
                }
              }}
            >
              <SelectTrigger className="w-[200px]">
                <SelectValue placeholder="Installation Status"/>
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="">All Sensor Kits</SelectItem>
                <SelectItem value="true">Has Current Installation</SelectItem>
                <SelectItem value="false">No Current Installation</SelectItem>
              </SelectContent>
            </Select>
          </QuickTooltip>
        </div>
      </div>
    </Card>
  );
};
